<template>
  <div style="padding: 0 24px">
    <StatementForm source="storageAreas"></StatementForm>
    <exportBtn></exportBtn>
    <WmsTable :is-pagination="false" :columns="columns"> </WmsTable>
  </div>
</template>

<script>
import StatementForm from "@/views/statement/components/form";
import exportBtn from "@/views/statement/components/exportBtn";
import WmsTable from "@/components/WmsTable";

import { StorageAreasColums } from "@/views/statement/StorageAreasColumsData";
export default {
  name:"statement_storageAreas",
  components: { StatementForm, exportBtn, WmsTable },
  props: {},
  data() {
    return {
      columns: StorageAreasColums,
    };
  },

  created() {},

  methods: {},
};
</script>

<style scoped lang="less"></style>
